import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export function FormHelpPanel() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Form Help</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3 text-sm text-gray-600">
        <div>
          <strong>Required fields</strong> are marked with an asterisk (*).
        </div>
        <div>
          <strong>Keyboard shortcuts:</strong>
          <ul className="mt-1 space-y-1">
            <li>• Ctrl+S: Save form</li>
            <li>• Esc: Cancel</li>
          </ul>
        </div>
        <div>
          <strong>Legal Structure:</strong> Structures vary by domicile country.
          Select country first to see available options.
        </div>
        <div>
          <strong>Amounts:</strong> Enter amounts in the base currency without
          separators (e.g., 150000000 for €150M).
        </div>
      </CardContent>
    </Card>
  );
}
